import { FormControl, FormGroup } from '@angular/forms';
import { FamilyMemberFormModel } from './family-member-form.model';
import { BeneficiaryDetailsFormBuilder } from '../../../shared/components/beneficiary/form-beneficiary-details/form-group/beneficiary-details.form.builder';
import { AddressFormBuilder } from '../../../shared/components/address/form-address/form-group/address.form.builder';
import { CzlonekRodziny } from '../../../shared/models/czlonek-rodziny';
import { FamilyMemberSchoolFormBuilder } from '../components/form-family-member-school/form-group/family-member-school.form.builder';

export class FamilyMemberFormBuilder {
  public static createFormGroup(
    czlonekRodziny?: CzlonekRodziny,
  ): FormGroup<FamilyMemberFormModel> {
    return new FormGroup<FamilyMemberFormModel>({
      id: new FormControl(czlonekRodziny?.id || null),
      details: BeneficiaryDetailsFormBuilder.createFormGroup(czlonekRodziny),
      address: AddressFormBuilder.createFormGroup(
        czlonekRodziny?.adres || undefined,
      ),
      school: FamilyMemberSchoolFormBuilder.createFormGroup(
        czlonekRodziny?.szkola || undefined,
      ),
    });
  }

  public static toModel(fg: FormGroup<FamilyMemberFormModel>): CzlonekRodziny {
    const czlonekRodziny = new CzlonekRodziny();
    czlonekRodziny.id = fg.controls.details.controls.id.value;
    czlonekRodziny.imie = fg.controls.details.controls.imie.value;
    czlonekRodziny.drugieImie = fg.controls.details.controls.drugieImie.value;
    czlonekRodziny.nazwisko = fg.controls.details.controls.nazwisko.value;
    czlonekRodziny.pesel = fg.controls.details.controls.pesel.value;
    czlonekRodziny.obywatelstwo =
      fg.controls.details.controls.obywatelstwo.value;
    czlonekRodziny.stanCywilny = fg.controls.details.controls.stanCywilny.value;
    czlonekRodziny.dataUrodzenia =
      fg.controls.details.controls.dataUrodzenia.value;
    czlonekRodziny.rodzajDokumentu =
      fg.controls.details.controls.rodzajDokumentu.value;
    czlonekRodziny.nrDokumentu = fg.controls.details.controls.nrDokumentu.value;
    czlonekRodziny.plec = fg.controls.details.controls.plec.value;

    // Mapowanie adresu
    czlonekRodziny.adres = AddressFormBuilder.mapAdres(fg.controls.address);

    // Mapowanie danych szkoły
    czlonekRodziny.szkola = FamilyMemberSchoolFormBuilder.toModel(
      fg.controls.school,
    );

    return czlonekRodziny;
  }
}
